import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  registerSetIsLoadingReducerType,
  registerSetIpAddressReducerType,
  registerSetDataReducerType,
  registerSetRegisterFailReducerType,
} from './RegisterConstants';

export const initialState = Map({
  data: {
    firstName: '',
    lastName: '',
    userName: '',
    email: '',
    password: '',
    repeatPassword: '',
    rememberMe: true,
    licenseAgreement: false,
    marketingInfo: false,
  },
  registerFail: null,
  ipAddress: null,
  isLoading: false,
});

const spec = {
  [registerSetIpAddressReducerType]: (state, action) => {
    const { ipAddress } = action.payload;
    return state.set('ipAddress', ipAddress);
  },
  [registerSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [registerSetDataReducerType]: (state, action) => {
    const currentData = state.get('data');
    return state.set('data', { ...currentData, ...action.payload });
  },
  [registerSetRegisterFailReducerType]: (state, action) => {
    return state.set('registerFail', action.payload);
  },
};

export default createReducerBySpec(spec, initialState);
